
  export default {
    url: "https://gigi.garena.vn",
    apiUrl: "https://gigi.garena.vn/",
    realtimeServerAddress: "http://localhost:8901/"
  }